import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * 公開故事整理／作者授權：在 JSON.parse 前把超過 Number.MAX_SAFE_INTEGER 的 snowflake ID 轉成字串。
 */
function parseStoryJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:publicationId|memoryEntryId|journeyId|nextCursorItemId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseStoryJson] };

/** ID 一律以字串送出，避免大數精度遺失。 */
const idString = (value) => String(value);

export const journeyStoryApi = {
  /** 僅行程擁有者可讀取（後端以公開版本擁有者判斷）。 */
  listItems: (journeyId) => travelClient.get(
    travelEndpoints.journeyPublicationStoryItems(journeyId),
    snowflakeJson,
  ),
  setSelection: (journeyId, memoryEntryId, selected) => travelClient.put(
    travelEndpoints.journeyPublicationStoryItemSelection(journeyId, memoryEntryId),
    { selected: Boolean(selected) },
    snowflakeJson,
  ),
  reorder: (journeyId, { memoryEntryIds, expectedStoryRevision }) => travelClient.put(
    travelEndpoints.journeyPublicationStoryOrder(journeyId),
    { memoryEntryIds: (memoryEntryIds || []).map(idString), expectedStoryRevision },
    snowflakeJson,
  ),
  /** 僅回憶作者本人可讀寫；不得代他人授權。 */
  getConsent: (journeyId, memoryEntryId) => travelClient.get(
    travelEndpoints.journeyMemoryPublicationConsent(journeyId, memoryEntryId),
    snowflakeJson,
  ),
  /** 「我的」跨行程本人授權清單；範圍由登入身分決定，不送作者參數。 */
  listMine: ({ cursorItemId, limit } = {}) => {
    const params = new URLSearchParams();
    if (cursorItemId) params.set('cursorItemId', String(cursorItemId));
    if (limit) params.set('limit', String(limit));
    const query = params.toString();
    return travelClient.get(
      `${travelEndpoints.mePublicationConsents()}${query ? `?${query}` : ''}`,
      snowflakeJson,
    );
  },
  setConsent: (journeyId, memoryEntryId, granted) => travelClient.put(
    travelEndpoints.journeyMemoryPublicationConsent(journeyId, memoryEntryId),
    { granted: Boolean(granted) },
    snowflakeJson,
  ),
};
